import { render, staticRenderFns } from "./KassaSverka.vue?vue&type=template&id=0cb4bdb1&scoped=true"
import script from "./KassaSverka.vue?vue&type=script&lang=js"
export * from "./KassaSverka.vue?vue&type=script&lang=js"
import style0 from "./KassaSverka.vue?vue&type=style&index=0&id=0cb4bdb1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb4bdb1",
  null
  
)

export default component.exports